import React, {  Component } from 'react';
import { connect } from 'react-redux';

class AvailabilityMismatchAndUpdateActionOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog();
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmApproveRequestDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow" style={{top: 122}}>
                    <h2 className="title">Action</h2>
                    <p>One or more of the products on the order are no longer available. Please select an action for the unavailable products.</p>
                    <a className="blueButton yesButton" onClick={this.closeDialog.bind(this)}>Ok</a>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return { state };
};

AvailabilityMismatchAndUpdateActionOverlayDialog = connect(mapStateToProps)(AvailabilityMismatchAndUpdateActionOverlayDialog);
export default AvailabilityMismatchAndUpdateActionOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/availabilityMismatchAndUpdateActionOverlayDialog.js